import React, { Component } from 'react';

import './styles.css';


class ASNTable extends Component {

    handleQtyChange = (e, index) => {
        let value = e.target.value;
        this.props.data[index].qty = value;
        this.props.data[index].qtyChanged = true;
        this.props.qtyValue(this.props.data);
    }

    onCheckboxChange = (data, index) => {
        this.props.checkboxChange(data);            
    }

    checkAll = (e) => {
        this.props.selectAllCheckbox(e);
    }

    render() {    


        return(
            <div className="table-responsive">
                <table className="table table-sm table-striped table-bordered ">
                    <thead>
                        <tr>
                            <th className="text-center">Select<br/><input type="checkbox" onChange={e => this.checkAll(e.target.checked)}/></th>
                            <th className="text-center">PO #</th>
                            <th className="text-center">Suffix</th>
                            <th className="text-center">Logistics Flag</th>
                            <th className="text-center">PO Mgmnt</th>
                            <th className="text-center">Vendor</th>
                            <th className="text-center">Vendor Name</th>
                            <th className="text-center">Item #</th>
                            <th className="text-center">ASN Qty</th>
                            <th className="text-center">Last Modify</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.data.map((data, key) => {
                            return(
                                <tr  key={key}>
                                    <td className="text-center"><input type="checkbox" checked={data.checked} onChange={e => this.onCheckboxChange(data, data.index)}/></td>
                                    <td className="text-center">{data.poNumber}</td>
                                    <td className="text-center">{data.suffix}</td>
                                    <td className="text-center">{data.logExport}</td>
                                    <td className="text-center">{data.mgtType}</td>
                                    <td className="text-center">{data.vendorId}</td>
                                    <td className="text-center">{data.vendorName}</td>
                                    <td className="text-center">{data.itemNumber}</td>
                                    <td className="text-center"><input type="number" name="qty" value={data.qty} className="input-asntable-qty" onChange={e => this.handleQtyChange(e, key)}/>
                                    {data.uploadedData === true? <i className="material-icons asn-cell-warning">warning</i> : data.qtyChanged === true? <i className="material-icons asn-cell-warning">warning</i>: ''}</td>
                                    <td className="text-center">{data.displayDate}</td>

                                </tr>
                            )
                        })}
                    </tbody>

                </table>
            </div>

        );
    }


}

export default ASNTable;